import {AxiosInstance} from "axios";
import {
    ConversationMessage,
    ConversationMessageSourceOption,
    ConversationMessageTriggerType
} from "@/conversation/interfaces";
import {PaginatedData, PaginationRequest} from "@/core/interfaces/api";

export interface ConversationMessageIndexQueryParams extends PaginationRequest {
    sourceable_type?: string;
    sourceable_id?: number;
    trigger_type?: ConversationMessageTriggerType;
    has_interaction?: 1 | 0;
    with?: ('sourceable')[]
}

const ConversationResource = (client: AxiosInstance) => {
    return {
        async customerConversation(customerId: number, params: PaginationRequest = {}): Promise<PaginatedData<ConversationMessage[]>> {
            return client.get(`customers/${customerId}/conversation/messages`, {params})
                .then((response) => response.data);
        },

        /**
         * Index the conversation messages.
         */
        async conversationMessages(params: ConversationMessageIndexQueryParams = {}): Promise<PaginatedData<ConversationMessage[]>> {
            return client.get(`conversation-messages`, {params})
                .then((response) => response.data);
        },

        /**
         * List the distinct message sources of the organization.
         */
        async conversationMessageSources(): Promise<{data: ConversationMessageSourceOption[]}> {
            return client.get(`conversation-messages/sources`)
                .then((response) => response.data);
        }
    };
};

export default ConversationResource;
